// src/utils/mapProduct.js
import { PRODUCT_TAGS } from "../data/products";

export function mapBackendProduct(p) {
  const tags = [];
  if (p.is_new_in) tags.push(PRODUCT_TAGS.NEW_IN);
  if (p.is_bestseller) tags.push(PRODUCT_TAGS.BESTSELLER);

  let images = [];

  if (Array.isArray(p.images)) {
    images = p.images;
  } else if (typeof p.images === "string") {
    try {
      const parsed = JSON.parse(p.images);
      if (Array.isArray(parsed)) images = parsed;
    } catch (e) {}
  }

  if (!images.length) {
    images = ["/images/placeholder-product.jpg"];
  }

  return {
    id: p.id,
    public_id: p.public_id,
    slug: p.seo_slug,

    nameEN: p.name_en,
    nameAR: p.name_ar,

    price: Number(p.base_price),
    discount: p.on_sale ? Number(p.sale_percent) : 0,

    totalStock: Number(p.total_stock) || 0,
    tags,

    sizes: (p.sizes || []).map((s) => ({
      size: s,
      inStock: true,
    })),

    colors: (p.colors || []).map((c) => ({
      name: c.name,
      code: c.code,
    })),

    images,

    category: p.primary_category || null,
    categories: p.categories || [],

    heelHeight: null,
  };
}

